module.exports = __webpack_public_path__ + "img/verified-black-24-dp.5e001430.svg";